module.exports = __webpack_public_path__ + "img/helping-hands.9226ac43.jpg";